// Compte client d'une entrée ou d'une sortie, choisi par un administrateur (vide = équipe).
import { useEffect, useState } from "react";
import { api, unwrap } from "../api/client";
import { isAdmin, useSession } from "../lib/auth";
import { t } from "../lib/i18n";
import { Field, Select } from "./ui";

export function OwnerSelect({ id, value, onChange }: { id: string; value: string | null; onChange: (v: string | null) => void }) {
  const { me } = useSession();
  const [clients, setClients] = useState<string[]>([]);
  useEffect(() => {
    if (!isAdmin(me.role)) return;
    unwrap(api.GET("/api/users"))
      .then((users) => setClients(users.filter((u) => u.role === "client").map((u) => u.username)))
      .catch(() => setClients([]));
  }, [me.role]);
  // seul un administrateur choisit ; les autres gardent le propriétaire tel quel (aucun compte client : rien à choisir)
  if (!isAdmin(me.role) || (clients.length === 0 && !value)) return null;
  return (
    <Field label={t("Client")} htmlFor={id} hint={t("Le client voit et gère cette ressource depuis son compte, dans ses limites.")}>
      <Select id={id} value={value ?? ""} onChange={(e) => onChange(e.target.value || null)}>
        <option value="">{t("Aucun (équipe)")}</option>
        {[...new Set([...clients, ...(value ? [value] : [])])].map((c) => <option key={c} value={c}>{c}</option>)}
      </Select>
    </Field>
  );
}
